export default __webpack_public_path__ + "static/media/discounts-2-off-new-items-image.6a292ef3.svg";